import {InvoicesAPI} from "../api/InvoicesAPI";
import {BaseService} from "./BaseService";
import {Invoice} from "../models/Invoice";
import {
	actionInvoiceFetchAllCompleted,
	actionInvoiceFetchCompleted,
	actionInvoiceSaveCompleted,
	actionInvoiceDeleteCompleted,
	actionDeleteInvoicesCompleted,
	actionInvoiceItemSaveCompleted,
	actionInvoiceItemDeleteCompleted,
	actionInvoiceFetchByCustomerCompleted
} from "../store/invoices/actions";
import {
	actionDeleteTabForItemId,
	actionSetTabItem,
	actionSetTabStateItem,
	actionUpdateTabStateItem
} from "../store/tabs/actions";
import {InvoiceItem} from "../models/InvoiceItem";
import {InvoiceItemsAPI} from "../api/InvoiceItemsAPI";
import {ErrorService} from "./ErrorService";
import {Customer} from "../models/Customer";
import {isNodeArray} from "tslint/lib/rules/typedefRule";
import {actionToastrInfo} from "../store/global";

export default class InvoicesService extends BaseService {

	static getAll() {
		let invoicesAPI: InvoicesAPI = new InvoicesAPI()
		invoicesAPI.getAll().then(InvoicesService.processResponse)
		.then((data) => actionInvoiceFetchAllCompleted(InvoicesService.responseToInvoices(data)))
		.catch(error => ErrorService.handleError(error))
	}

	static save(invoice: Invoice) {
		let invoicesAPI: InvoicesAPI = new InvoicesAPI()
		if (invoice.id) {
			invoicesAPI.put(InvoicesService.invoiceToRequest(invoice)).then(InvoicesService.processResponse)
			.then((data) => {
				actionInvoiceSaveCompleted(InvoicesService.responseToInvoice(data))
				actionSetTabStateItem(InvoicesService.responseToInvoice(data))
				actionSetTabItem(InvoicesService.responseToInvoice(data))
				actionToastrInfo("Info", "Račun je uspešno snimljen")
			})
			.catch(error => ErrorService.handleError(error))
		} else {
			invoicesAPI.post(InvoicesService.invoiceToRequest(invoice)).then(InvoicesService.processResponse)
				.then((data) => {
					actionInvoiceSaveCompleted(InvoicesService.responseToInvoice(data))
					actionSetTabItem(InvoicesService.responseToInvoice(data))
					actionSetTabStateItem(InvoicesService.responseToInvoice(data))
					actionToastrInfo("Info", "Račun je uspešno snimljen")
				})
				.catch(error => ErrorService.handleError(error))
		}
	}

	static getOne (invoice: Invoice) {
		const invoicesAPI: InvoicesAPI = new InvoicesAPI()
		invoicesAPI.get(invoice).then(InvoicesService.processResponse)
		.then((data) => {
			actionInvoiceFetchCompleted(InvoicesService.responseToInvoice(data))
		})
		.catch(error => ErrorService.handleError(error))
	}

	static delete(invoice: Invoice) {
		const invoicesAPI: InvoicesAPI = new InvoicesAPI()
		invoicesAPI.delete(invoice).then(
			(data) => {
				actionDeleteTabForItemId(invoice.id)
				actionInvoiceDeleteCompleted(invoice)
			}
		).catch(error => ErrorService.handleError(error))
	}

	static deleteInvoices(invoices: Invoice[]) {

		const invoicesAPI: InvoicesAPI = new InvoicesAPI()
		let count = 0;
		invoices.forEach(invoice => {

			invoicesAPI.delete(InvoicesService.invoiceToRequest(invoice)).then(InvoicesService.processResponse).then(
				(data) => {
					count++;
					actionDeleteTabForItemId(invoice.id)
					if(count === invoices.length)
						actionDeleteInvoicesCompleted(invoices)
				}
			).catch(error => ErrorService.handleError(error))
		});
	}

	static saveInvoiceItem(invoiceItem: InvoiceItem, index: number) {
		let api: InvoiceItemsAPI = new InvoiceItemsAPI(invoiceItem.invoiceId)
		if (invoiceItem.id) {
			api.put(InvoicesService.invoiceItemToRequest(invoiceItem)).then(InvoicesService.processResponse)
				.then((data) => {
					actionInvoiceItemSaveCompleted(InvoicesService.responseToInvoiceItem(data), index)
					actionUpdateTabStateItem(InvoicesService.responseToInvoiceItem(data), 'invoiceItems', index)
					// actionInvoiceSaveCompleted(InvoicesService.responseToInvoice(data))
					// actionSetTabStateItem(InvoicesService.responseToInvoice(data))
					// actionSetTabItem(InvoicesService.responseToInvoice(data))
				})
				.catch(error => ErrorService.handleError(error))
		} else {
			api.post(InvoicesService.invoiceItemToRequest(invoiceItem)).then(InvoicesService.processResponse)
				.then((data) => {
					actionInvoiceItemSaveCompleted(InvoicesService.responseToInvoiceItem(data), index)
					actionUpdateTabStateItem(InvoicesService.responseToInvoiceItem(data), 'invoiceItems', index)
					// actionInvoiceSaveCompleted(InvoicesService.responseToInvoice(data))
					// actionSetTabItem(InvoicesService.responseToInvoice(data))
					// actionSetTabStateItem(InvoicesService.responseToInvoice(data))
				})
				.catch(error => ErrorService.handleError(error))
		}
	}

	static deleteInvoiceItem(invoiceItem: InvoiceItem) {

		let api: InvoiceItemsAPI = new InvoiceItemsAPI(invoiceItem.invoiceId)
		api.delete(InvoicesService.invoiceItemToRequest(invoiceItem)).then(InvoicesService.processResponse).then(
			(data) => {
				actionInvoiceItemDeleteCompleted()
			}
		).catch(error => ErrorService.handleError(error))
	}


	static responseToInvoice (data: any): Invoice {
		let invoice = new Invoice()
		invoice.id = data.id
		invoice.description = data.description
		invoice.number = data.number
		invoice.issueDate = data.issueDate
		invoice.deliveryDate = data.deliveryDate
		invoice.dueDate = data.dueDate
		invoice.customerId = data.customerId
		invoice.contractId = data.contractId
		invoice.uploads = data.uploads
		invoice.invoiceItems = []
		invoice.price = data.price
		invoice.type = data.type
		invoice.progressInvoiceIds = data.progressInvoiceIds
		invoice.vat = data.vat
		if (data.invoiceItems) {
			for (let ii of data.invoiceItems) {
				invoice.invoiceItems.push(InvoicesService.responseToInvoiceItem(ii))
			}
		}
		return invoice
	}

	static responseToInvoices (data: any): Invoice[] {
		let invoices: Invoice[] = []
		for (let invoice of data) {
			invoices.push(InvoicesService.responseToInvoice(invoice))
		}
		return invoices
	}

	static responseToInvoiceItem (data: any): InvoiceItem {
		let item = new InvoiceItem()
		item.id = data.id
		item.title = data.title
		item.customerId = data.customerId
		item.invoiceId = data.invoiceId
		item.amount = data.amount
		item.unitPrice = data.unitPrice
		item.unitName = data.unitName
		item.serviceId = data.serviceId
		item.vat = data.vat
		return item
	}


	static invoiceToRequest (invoice: Invoice): any {
		invoice.uploads = null
		invoice.contractId = invoice.contractId ? invoice.contractId : undefined
		return invoice
	}

	static invoiceItemToRequest (invoiceItem: InvoiceItem): any {
		return invoiceItem
	}

	static 	calculatePriceAndVat(invoice: Invoice): Invoice {
		invoice.price = 0
		invoice.vat = 0
		for (let item of invoice.invoiceItems) {
			item = InvoicesService.calculatePriceAndVatInoviceItem(item)
			invoice.price += item.priceWithVat
			invoice.vat += item.vatValue
		}
		return invoice
	}

	static calculatePriceAndVatInoviceItem (invoiceItem: InvoiceItem): InvoiceItem {
		let amount = invoiceItem.amount ? invoiceItem.amount : 0
		let unitPrice = invoiceItem.unitPrice ? invoiceItem.unitPrice : 0
		invoiceItem.price = amount * unitPrice
		invoiceItem.vatValue = invoiceItem.price * invoiceItem.vat / 100
		invoiceItem.priceWithVat = invoiceItem.price + invoiceItem.vatValue
		return invoiceItem
	}

	static getAllByCustomer(customer: Customer) {
		let invoicesAPI: InvoicesAPI = new InvoicesAPI()
		invoicesAPI.getByCustomer(customer.id)
			.then(InvoicesService.processResponse)
			.then((data) => actionInvoiceFetchByCustomerCompleted(data))
			.catch(error => ErrorService.handleError(error))
	}
}
